import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=1dca09f8&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"
import style0 from "./LangSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dca09f8')) {
      api.createRecord('1dca09f8', component.options)
    } else {
      api.reload('1dca09f8', component.options)
    }
    module.hot.accept("./LangSelect.vue?vue&type=template&id=1dca09f8&", function () {
      api.rerender('1dca09f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Common/LangSelect.vue"
export default component.exports